import {defineStore} from 'pinia'

export const useMsalStore = defineStore('msal', {
    state: () => ({
        msalConfig: {
            auth: {
                clientId: 'd6ecb4a5-e74d-4b20-b44d-fc88f6380fa4',
                authority: 'https://pattanb2c.b2clogin.com/pattanb2c.onmicrosoft.com/b2c_1a_accountlink_susi',
            },
            cache: {
                cacheLocation: 'sessionStorage',
            },
        },
        accessToken: '',
        authorityDomain: 'pattanb2c.b2clogin.com',
        policy: 'b2c_1a_accountlink_susi',
    }),
    actions: {
        setAccessToken( token ) {
           this.accessToken = token
        }
    },
    getters: {
        getAccessToken(){
            return this.accessToken
        }
    }
})